module.exports = __webpack_public_path__ + "static/media/logo.7d90a61d.png";


//////////////////
// WEBPACK FOOTER
// ./public/media/images/logo.png
// module id = 39
// module chunks = 0